'use strict';

var debugEnum = require('spotify-debug-tools/debug_enum');

var Errors = {
  DEALER_CONNECTION_ERROR: 'DEALER_CONNECTION_ERROR',
  DEALER_AUTHENTICATION_FAILED: 'DEALER_AUTHENTICATION_FAILED',
  DEALER_ERROR: 'DEALER_ERROR',
  HTTP_REQUEST_FAILED: 'HTTP_REQUEST_FAILED',
  LOGGING_REQUEST_FAILED: 'LOGGING_REQUEST_FAILED',
  TRANSPORT_ENDPOINTS_PROVIDER_ERROR: 'TRANSPORT_ENDPOINTS_PROVIDER_ERROR',
  TRANSPORT_INVALID_TOKEN: 'TRANSPORT_INVALID_TOKEN',
  TRANSPORT_TOKEN_PROVIDER_ERROR: 'TRANSPORT_TOKEN_PROVIDER_ERROR',
  TRANSPORT_LIFECYCLE_DISABLED: 'TRANSPORT_LIFECYCLE_DISABLED',
  XRESOLVE_INCOMPLETE_RESPONSE: 'XRESOLVE_INCOMPLETE_RESPONSE',
  XRESOLVE_INVALID_RESPONSE: 'XRESOLVE_INVALID_RESPONSE',
  XRESOLVE_REQUEST_FAILED_WITH_STATUS: 'XRESOLVE_REQUEST_FAILED_WITH_STATUS'
};

module.exports = debugEnum(Errors);
